import { Parenthesized } from '@mews-commander/ui';
import { lt } from '@mews/framework';
import { useExpirationDaysLeftCount } from './hooks/useExpirationDaysLeftCount';

interface DaysLeftTextProps {
    expirationDate?: string;
}
export const ExpirationDaysLeftText = ({ expirationDate }: DaysLeftTextProps) => {
    const expirationDaysLeftCount = useExpirationDaysLeftCount(expirationDate);

    if (expirationDaysLeftCount == null) {
        return null;
    }

    return (
        <Parenthesized>
            {lt('ContractSignatureStatusPendingDaysLeftLabel', { daysLeft: expirationDaysLeftCount })}
        </Parenthesized>
    );
};
